"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookieService = void 0;
var _stringToBool = require("./stringToBool");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CookieService = exports.CookieService = /*#__PURE__*/function () {
  function CookieService() {
    _classCallCheck(this, CookieService);
  }
  return _createClass(CookieService, [{
    key: "stringifyAttribute",
    value: function stringifyAttribute(name, value) {
      if (!value) {
        return "";
      }
      var stringified = "; " + name;
      if (value === true) {
        return stringified; // boolean attributes shouldn't have a value
      }
      return stringified + "=" + value;
    }
  }, {
    key: "stringifyAttributes",
    value: function stringifyAttributes(attributes) {
      if (typeof attributes.expires === "number") {
        var expires = new Date();
        expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e5);
        attributes.expires = expires;
      }
      return this.stringifyAttribute("Expires", attributes.expires ? attributes.expires.toUTCString() : "") + this.stringifyAttribute("Domain", attributes.domain) + this.stringifyAttribute("Path", attributes.path) + this.stringifyAttribute("Secure", attributes.secure) + this.stringifyAttribute("SameSite", attributes.sameSite);
    }
  }, {
    key: "encode",
    value: function encode(name, value, attributes) {
      return encodeURIComponent(name).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent) // allowed special characters
      .replace(/\(/g, "%28").replace(/\)/g, "%29") +
      // replace opening and closing parens
      "=" + encodeURIComponent(value).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) +
      // allowed special characters
      this.stringifyAttributes(attributes);
    }
  }, {
    key: "parse",
    value: function parse(cookieString) {
      var result = {};
      var cookies = cookieString ? cookieString.split("; ") : [];
      var rdecode = /(%[0-9A-Z]{2})+/g;
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split("=");
        var cookie = parts.slice(1).join("=");
        if (cookie.charAt(0) === '"') {
          cookie = cookie.slice(1, -1);
        }
        try {
          var name = parts[0].replace(rdecode, decodeURIComponent);
          result[name] = cookie.replace(rdecode, decodeURIComponent);
        } catch (e) {
          // ignore cookies with invalid name/value encoding
        }
      }
      return result;
    }
  }, {
    key: "getAll",
    value: function getAll(prefix) {
      var data = this.parse(document.cookie);
      var config = {};

      //ensure its correct type.
      Object.keys(data).forEach(function (a) {
        var cleaned = a.replace(prefix, "");
        if (data[a] && ["sound", "fastPlay", "autoAdjustBet", "vibrate", "blitzStopOnFeature", "splashScreenHide", "blitzSplashScreenHide", "spaceToSpin", "hideCurrencySign"].indexOf(cleaned) > -1) {
          config[cleaned] = (0, _stringToBool.stringToBool)(data[a]);
        }
      });
      return config;
    }
  }, {
    key: "get",
    value: function get(prefix, name) {
      return this.getAll(prefix)[name];
    }
  }, {
    key: "set",
    value: function set(prefix, name, value, attributes) {
      document.cookie = this.encode(prefix + name, value, _objectSpread({
        path: "/"
      }, attributes));
    }
  }, {
    key: "remove",
    value: function remove(prefix, name, attributes) {
      this.set(prefix, name, "", _objectSpread(_objectSpread({}, attributes), {}, {
        expires: -1
      }));
    }
  }]);
}();
//# sourceMappingURL=cookieService.js.map